export enum PermissionApplication {
	CX_STUDIO = 'CX_STUDIO',
	ACQ = 'ACQ'
}